"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    number: "01",
    label: "پروژه‌های جدید",
    description: "برای مشاوره در خصوص پروژه‌های بازطراحی فضاهای مسکونی و همکاری‌های معماری.",
    email: "projects@arq.studio",
    phone: "(۰۲۱) ۸۸۷۶-۵۴۳۲",
    contactName: "آرتین",
    contactRole: "مدیر استودیو"
  }, {
    number: "02",
    label: "مشتریان فعلی",
    description: "پشتیبانی اختصاصی برای پروژه‌های در حال اجرا، درخواست‌های خدمات و اصلاحات سیستم.",
    email: "clients@arq.studio",
    phone: "(۰۲۱) ۸۸۷۶-۵۴۳۳",
    contactName: "سارا",
    contactRole: "مهندس ارشد طراحی"
  }, {
    number: "03",
    label: "رسانه و مطبوعات",
    description: "درخواست‌های تحریریه، مصاحبه‌ها و همکاری‌های رسانه‌ای برای نشریات و ویژگی‌های طراحی.",
    email: "press@arq.studio",
    phone: "(۰۲۱) ۸۸۷۶-۵۴۳۴",
    contactName: "نیما",
    contactRole: "مدیر هنری"
  }, {
    number: "04",
    label: "فرصت‌های شغلی",
    description: "فرصت‌های پیوستن به تیمی که آینده طراحی داخلی مدرن و هوشمند را تعریف می‌کند.",
    email: "careers@arq.studio",
    phone: "(۰۲۱) ۸۸۷۶-۵۴۳۵",
    contactName: "آرتین",
    contactRole: "مدیر استودیو"
  }];
  return <section data-section-id="4795" id="پلهای-ارتباطی" className="dark bg-background text-foreground py-24 md:py-32 lg:py-44 px-6 md:px-10 lg:px-16">
      <div ref={ref} className={`max-w-[1400px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-20 md:mb-28 lg:mb-32">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs tracking-[0.25em] text-primary mb-8 md:mb-10" style={{
            fontFamily: "var(--font-mono)"
          }}>
              — پل‌های ارتباطی
            </div>
            <h2 className="font-default font-bold text-5xl md:text-7xl lg:text-[88px] leading-[0.95] tracking-tight text-foreground">
              گفتگوی{" "}
              <span className="italic font-normal" style={{
              fontFamily: "var(--font-serif)"
            }}>
                مستقیم.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex lg:items-end">
            <p className="text-lg md:text-xl leading-relaxed text-foreground/70" style={{
            fontFamily: "var(--font-serif)"
          }}>
              راه‌های ارتباطی تخصصی برای نیازهای شما. هر بخش توسط یکی از مدیران ارشد استودیو هدایت می‌شود.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-border">
          {departments.map((dept, i) => <div data-index={i} key={dept.number} className={`group relative flex flex-col px-0 md:px-8 lg:px-10 py-12 md:py-14 transition-colors duration-500 hover:bg-accent/40 ${i < departments.length - 1 ? "border-b border-border md:border-b lg:border-b-0" : ""} ${i % 2 === 0 ? "md:border-r md:border-border" : ""} ${i < 2 ? "md:border-b md:border-border lg:border-b-0" : ""} lg:border-r lg:border-border lg:last:border-r-0`}>
              {}
              <div className="font-mono text-[11px] tracking-[0.25em] text-primary mb-10 md:mb-14" style={{
            fontFamily: "var(--font-mono)"
          }}>
                {dept.number} / {dept.label}
              </div>

              {}
              <p className="text-2xl leading-[1.3] text-foreground mb-14 md:mb-20 flex-1" style={{
            fontFamily: "var(--font-serif)"
          }}>
                {dept.description}
              </p>

              {}
              <div className="space-y-6">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    ایمیل
                  </div>
                  <Link to={`mailto:${dept.email}`} className="text-base text-foreground hover:text-primary hover:underline decoration-primary underline-offset-4 transition-colors duration-300 break-all" style={{
                fontFamily: "var(--font-serif)"
              }}>
                    {dept.email}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    تلفن
                  </div>
                  <Link to={`tel:${dept.phone.replace(/[^\d+]/g, "")}`} className="text-base text-foreground hover:text-primary transition-colors duration-300" style={{
                fontFamily: "var(--font-serif)"
              }}>
                    {dept.phone}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    تماس با
                  </div>
                  <div className="text-base text-foreground" style={{
                fontFamily: "var(--font-serif)"
              }}>
                    <span className="italic">{dept.contactName}</span>
                    <span className="text-foreground/50"> / </span>
                    <span className="italic">{dept.contactRole}</span>
                  </div>
                </div>

                {}
                <div className="pt-8">
                  <Link to={`mailto:${dept.email}`} className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-primary hover:gap-4 transition-all duration-300" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    <ArrowRight className="size-3" />
                    ارسال ایمیل
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}